import React from 'react'

import { StyledFlowOption as S } from './FlowOption.styles'

type TProps = {
  children: React.ReactNode
  onClick: () => void
  isSelected?: boolean
  hasCheckbox?: boolean
}

export const FlowOption: React.FC<TProps> = ({
  children,
  onClick,
  isSelected = false,
  hasCheckbox = false,
}) => (
  <S.Option
    type="button"
    isSelected={isSelected}
    data-selected={isSelected}
    onClick={onClick}
    {...(hasCheckbox && { role: 'checkbox', 'aria-checked': isSelected })}
  >
    <S.Label>{children}</S.Label>
    {hasCheckbox && <S.Checkbox isChecked={isSelected} />}
  </S.Option>
)
